import _ from 'underscore';
import useSwr from 'swr';
import { edmCampaign } from '@bingads-webui/edm-campaign';

const pageSize = 10000;

export function getCampaignData({
  jsdata,
  isAdGroupLevel,
  campaignId,
}) {
  const filter = '(CampaignType ne Enum.CampaignType\'Smart\')';

  const $select = [
    'Id',
    'Name',
    'Status',
    'CampaignType',
    'CampaignSubType',
    'CampaignSettings',
  ].join(', ');

  const formatQuery : {
    $select: string,
    $skip: number,
    $top: number,
    $orderby: string,
    $filter?: string,
  } = {
    $select,
    $skip: 0,
    $top: pageSize,
    $orderby: 'Name asc',
  };

  if (filter) {
    formatQuery.$filter = filter;
  }

  return jsdata.Campaign.findAll({
    query: formatQuery,
  }).then((data) => {
    const dataList = _.map(data, (item : {
      Id: number,
      Name: string,
    }) => ({
      value: item.Id.toString(),
      content: item.Name,
      allowedCheck: !isAdGroupLevel,
    }));

    if (campaignId) {
      return dataList.filter(item => item.value === campaignId.toString());
    }

    return dataList;
  }, (error) => {
    // TODO: handle error
  });
}

export function getAdGroupData({
  query,
  cid,
  aid,
  jsdata,
  campaignId,
}) {
  const signleQuoteTerminatedQuery = query.replace('\'', '\'\'');

  const filter = _.compact([
    query && `contains(Name, '${signleQuoteTerminatedQuery}')`,
  ]).join(' and ');

  const $expand = [
    'Id',
    'Name',
    'CampaignType',
    'CampaignSubType',
  ];

  const $select = [
    'Id',
    'Name',
    'Status',
    'Language',
  ].join(', ');

  const formatQuery : {
    $expand: string,
    $select: string,
    $skip: number,
    $top: number,
    $orderby: string,
    $filter?: string,
    $count: boolean,
  } = {
    $expand: `Campaign($select=${$expand.join(',')})`,
    $select,
    $orderby: 'Name asc',
    $skip: 0,
    $top: pageSize,
    $count: true,
  };

  if (campaignId) {
    _.extend(formatQuery, {
      entitySet: edmCampaign
        .Customers.$withKey(cid)
        .Accounts.$withKey(aid)
        .Campaigns
        .$withKey(Number(campaignId))
        .AdGroups
        .toJSON(),
    });
  }

  if (filter) {
    formatQuery.$filter = filter;
  }

  return jsdata.AdGroup.findAll({
    query: formatQuery,
  }).then(data => _.map(data, (item : {
    Id: number,
    Name: string,
  }) => ({
    value: item.Id.toString(),
    content: item.Name,
    parentValue: campaignId,
    allowedCheck: true,
  })), (error) => {
    // TODO: handle error
  });
}

export function useCampaignData({
  jsdata,
  isAdGroupLevel,
  campaignId,
}) {
  return useSwr({ jsdata, isAdGroupLevel, campaignId }, getCampaignData, {
    revalidateOnFocus: false,
  });
}
